import type { StaticImageData } from 'next/image';
import Link from 'next/link';

import { ArrowLeftSmall } from '@zoomit/icons';
import { IconButton, Image } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

export type Props = {
  // provider: InstallmentProviderItemType;
  provider: {
    url: string;
    logo: {
      src: string | StaticImageData;
      blurDataUrl?: string;
      alt: string;
    };
    title: string;
    description: string;
  };
};

const InstallmentProviderItem = (props: Props) => {
  const { provider } = props;
  return (
    <Link
      className="bg-card md:hover:bg-background1 flex w-full items-center justify-between gap-4 py-3 md:px-4"
      href={provider.url}
      target="_blank"
      rel="nofollow"
    >
      <div className="flex w-auto gap-4">
        <div className="flex w-auto items-center">
          <div className="relative h-10 w-10">
            <Image
              fill
              blurDataURL={provider.logo.blurDataUrl}
              src={provider.logo.src}
              alt={provider.logo.alt}
              sizes="96px"
            />
          </div>
        </div>
        <div className="flex w-10/12 flex-col">
          <Typography fontSize={1.3} fontWeight="bold" lineHeight="normal">
            {provider.title}
          </Typography>
          <Typography
            fontSize={1.2}
            lineHeight={2}
            className="line-clamp-1 w-full overflow-hidden text-ellipsis"
          >
            {provider.description}
          </Typography>
        </div>
      </div>
      <div className="flex w-1/12 justify-end">
        <IconButton>
          <ArrowLeftSmall />
        </IconButton>
      </div>
    </Link>
  );
};

export default InstallmentProviderItem;
